import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, ShoppingBag } from 'lucide-react';
const PURCHASES = ['Carolina de Mendoza acaba de comprar', 'Diego de La Plata acaba de comprar', 'Lucía de Tucumán acaba de comprar', 'Marcos de Córdoba acaba de comprar', 'Sofía de Buenos Aires acaba de comprar', 'Valentina de Rosario acaba de comprar'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(0);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerPopup();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const triggerPopup = () => {
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup (random between 25-40 seconds)
      const nextDelay = Math.floor(Math.random() * (40000 - 25000 + 1) + 25000);
      setTimeout(() => {
        setCurrentPurchase(prev => (prev + 1) % PURCHASES.length);
        triggerPopup();
      }, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-110">
      {isVisible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} className="fixed bottom-4 left-4 z-50 max-w-xs w-full bg-white rounded-lg shadow-lg border border-green-100 p-3 flex items-center gap-3" data-id="element-111">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-112">
            <ShoppingBag className="w-5 h-5 text-green-600" data-id="element-113" />
          </div>
          <div data-id="element-114">
            <p className="text-sm font-medium text-gray-900" data-id="element-115">
              {PURCHASES[currentPurchase]}
            </p>
            <div className="flex items-center gap-1 mt-0.5" data-id="element-116">
              <CheckCircle className="w-3 h-3 text-green-500" data-id="element-117" />
              <span className="text-xs text-green-600 font-medium" data-id="element-118">
                Verificado hace instantes
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}